module.exports = __webpack_public_path__ + "bg-banner.d02b3edf4f07fa992ca0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popular/img/bg-banner.jpg
// module id = ./src/assets/popular/img/bg-banner.jpg
// module chunks = 3